export function LegalPage({ kind }: { kind: "terms" | "privacy" }) {
  const isTerms = kind === "terms";
  return (
    <main className="legal-page">
      <article>
        <h1>{isTerms ? "TruthSeeker 用户协议" : "TruthSeeker 隐私政策"}</h1>
        <p>本页面用于公司统一用户中心接入的只读说明。正式部署配置了原平台协议地址时，注册页会优先打开原平台的现行文本。</p>
        {isTerms ? (
          <>
            <h2>账号与服务</h2>
            <p>账号注册、登录、验证码和密码管理由公司统一用户中心提供。使用本系统时，还应遵守公司原平台现行的用户协议。</p>
            <h2>科研内容</h2>
            <p>系统生成内容仅作为科研辅助信息。重要研究结论、引用和实验决策应由用户独立复核。</p>
          </>
        ) : (
          <>
            <h2>身份信息</h2>
            <p>本系统只保存公司用户稳定标识及必要资料快照；公司登录凭证仅在服务器端加密保存，浏览器只持有安全会话 Cookie。</p>
            <h2>业务数据</h2>
            <p>测试与正式环境的项目、对话、文件和运行日志相互隔离，不与公司旧平台业务数据库混用。</p>
          </>
        )}
        <p><a href="/">返回登录</a></p>
      </article>
    </main>
  );
}
